'use strict';

var utils = require('../utils');

function apply() {
  utils.patchClass('FileReader');
}

module.exports = {
  apply: apply
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zone.js/lib/patch/file-reader.js
 ** module id = 513
 ** module chunks = 1
 **/